var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "name": "translateY",
      "mode": "out-in"
    }
  }, [_vm.bannerLabel.label ? _c('div', {
    staticClass: "FeedbackBanner"
  }, [_c('div', {
    staticClass: "FeedbackBanner-label",
    class: ("FeedbackBanner-label--" + (_vm.bannerLabel.type)),
    attrs: {
      "id": ("js-feedback-label-" + (_vm.inputId)),
      "aria-label": _vm.bannerLabel.label,
      "tabindex": _vm.getTabIndex
    }
  }, [_vm.getIcon ? _c('animated-icon', {
    staticClass: "FeedbackBanner-icon",
    attrs: {
      "icon": _vm.getIcon,
      "size": '30'
    }
  }) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.bannerLabel.label))])], 1)]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }